/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Plh_IntroInputs */

const vi_scl_plh_intro = /** @type {(inputs: Scl_Plh_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi lại các lô đã khiêng ra khỏi kho lấy hương để đưa vào đóng gói. Phiếu không trừ tồn kho.`)
};

/**

* @param {Scl_Plh_IntroInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_plh_intro = /** @type {((inputs?: Scl_Plh_IntroInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Plh_IntroInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_plh_intro(inputs)
});